import { NgIf, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Output, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface CommomDialogData {
  title: string;
  confirmText?: string;
  cancelText?: string;
  SaveText?: string;
  SyncText?: string;
  template?: TemplateRef<any>;
  disableClose?: boolean;
  loading?: boolean;
  initialData?: any;
}

@Component({
  selector: 'app-commom-dialog',
  templateUrl: './commom-dialog.component.html',
  styleUrls: ['./commom-dialog.component.scss'],
  imports: [NgIf, NgTemplateOutlet, MatDialogModule]
})

export class CommonDialogComponent implements AfterViewInit {
  @Output() confirmed = new EventEmitter<boolean>();

  get loading(): boolean {
    return this.data.loading || false;
  }

  constructor(
    public dialogRef: MatDialogRef<CommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CommomDialogData,
    public cdr: ChangeDetectorRef
  ) {
    this.dialogRef.disableClose = true;
    this.removeEscapeKeyListener();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  private removeEscapeKeyListener(): void {
    this.dialogRef.backdropClick().subscribe(() => { });

    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  onConfirm(): void {
    if (this.loading) {
      return;
    }

    this.confirmed.emit(true);
    const confirmEvent = new CustomEvent('dialogConfirm', {
      detail: { source: 'dialog' },
      bubbles: true
    });
    document.dispatchEvent(confirmEvent);
  }

  closeDialog(result: boolean = true): void {
    this.dialogRef.close(result);
  }

  onCancel(): void {
    if (this.loading) {
      return;
    }

    this.confirmed.emit(false);
    this.dialogRef.close(false);
  }
}